import { render } from "./ExplainPanel.vue?vue&type=template&id=2551f06e&scoped=true"
import script from "./ExplainPanel.vue?vue&type=script&lang=js"
export * from "./ExplainPanel.vue?vue&type=script&lang=js"

import "./ExplainPanel.vue?vue&type=style&index=0&id=2551f06e&lang=scss&scoped=true"
import "./ExplainPanel.vue?vue&type=style&index=1&id=2551f06e&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2551f06e"]])

export default __exports__